// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.routeDiagram_root_ztr7n {
  display: flex;
  flex-flow: column nowrap;
  flex: 0 0 auto;
  align-items: flex-start;
  padding: 42px 3px 42px 42px;
  background: white;
  border-radius: var(--border-radius);

  --left-width: 10px;
  --right-width: 200px;

  --line-color: var(--hsl-blue);
  --line-width: 2px;
  --line-radius: 10px;
  --line-border: var(--line-width) solid var(--line-color);
}

.routeDiagram_a3_dZKna {
  padding: 15px 0px 5px 15px;
  border-radius: 30px;
  width: fit-content;
  min-width: 350px;
}

.routeDiagram_useWide_hPaqG {
  min-width: 548px;
}

.routeDiagram_componentName_IvGyG {
  padding: 0px 0px 20px;
  font-size: 30px;
  color: var(--hsl-blue);
}

.routeDiagram_componentNameA3_TdxLv {
  font-size: 20px;
  padding: 0px 0px 10px;
}

.routeDiagram_componentName_IvGyG > .routeDiagram_title_NNB14 {
  font-family: GothamRounded-Medium;
}

.routeDiagram_componentName_IvGyG > .routeDiagram_subtitle_KAgLU {
  font-family: GothamRounded-Book;
}

.routeDiagram_componentNameA3_TdxLv > .routeDiagram_titleA3_oUqbI {
  font-family: GothamRounded-Medium;
}

.routeDiagram_componentNameA3_TdxLv > .routeDiagram_subtitleA3_W01x1 {
  font-family: GothamRounded-Book;
}

.routeDiagram_start_nM_Pi {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: black;
  margin-left: var(--left-width);
  margin-bottom: calc(var(--line-width) * 2);
}

.routeDiagram_start_nM_Pi .routeDiagram_icon_SwryB {
  width: 30px;
  height: 36px;
  margin-left: -14px;
  margin-right: 5px;
}

.routeDiagram_start_nM_Pi .routeDiagram_title_NNB14 {
  font-family: GothamRounded-Medium;
  font-size: 18px;
  line-height: 22px;
}

.routeDiagram_start_nM_Pi .routeDiagram_titleA3_oUqbI {
  font-family: GothamRounded-Medium;
  font-size: 0.8em;
  line-height: 22px;
}

.routeDiagram_subtitleA3_W01x1 {
  font-family: GothamRounded-Book;
  font-size: 0.75em;
}

.routeDiagram_italics_RSjzp {
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/routeDiagram/routeDiagram.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,wBAAwB;EACxB,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,mCAAmC;;EAEnC,kBAAkB;EAClB,oBAAoB;;EAEpB,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".root {\n  display: flex;\n  flex-flow: column nowrap;\n  flex: 0 0 auto;\n  align-items: flex-start;\n  padding: 42px 3px 42px 42px;\n  background: white;\n  border-radius: var(--border-radius);\n\n  --left-width: 10px;\n  --right-width: 200px;\n\n  --line-color: var(--hsl-blue);\n  --line-width: 2px;\n  --line-radius: 10px;\n  --line-border: var(--line-width) solid var(--line-color);\n}\n\n.a3 {\n  padding: 15px 0px 5px 15px;\n  border-radius: 30px;\n  width: fit-content;\n  min-width: 350px;\n}\n\n.useWide {\n  min-width: 548px;\n}\n\n.componentName {\n  padding: 0px 0px 20px;\n  font-size: 30px;\n  color: var(--hsl-blue);\n}\n\n.componentNameA3 {\n  font-size: 20px;\n  padding: 0px 0px 10px;\n}\n\n.componentName > .title {\n  font-family: GothamRounded-Medium;\n}\n\n.componentName > .subtitle {\n  font-family: GothamRounded-Book;\n}\n\n.componentNameA3 > .titleA3 {\n  font-family: GothamRounded-Medium;\n}\n\n.componentNameA3 > .subtitleA3 {\n  font-family: GothamRounded-Book;\n}\n\n.start {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  color: black;\n  margin-left: var(--left-width);\n  margin-bottom: calc(var(--line-width) * 2);\n}\n\n.start .icon {\n  width: 30px;\n  height: 36px;\n  margin-left: -14px;\n  margin-right: 5px;\n}\n\n.start .title {\n  font-family: GothamRounded-Medium;\n  font-size: 18px;\n  line-height: 22px;\n}\n\n.start .titleA3 {\n  font-family: GothamRounded-Medium;\n  font-size: 0.8em;\n  line-height: 22px;\n}\n\n.subtitleA3 {\n  font-family: GothamRounded-Book;\n  font-size: 0.75em;\n}\n\n.italics {\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `routeDiagram_root_ztr7n`,
	"a3": `routeDiagram_a3_dZKna`,
	"useWide": `routeDiagram_useWide_hPaqG`,
	"componentName": `routeDiagram_componentName_IvGyG`,
	"componentNameA3": `routeDiagram_componentNameA3_TdxLv`,
	"title": `routeDiagram_title_NNB14`,
	"subtitle": `routeDiagram_subtitle_KAgLU`,
	"titleA3": `routeDiagram_titleA3_oUqbI`,
	"subtitleA3": `routeDiagram_subtitleA3_W01x1`,
	"start": `routeDiagram_start_nM_Pi`,
	"icon": `routeDiagram_icon_SwryB`,
	"italics": `routeDiagram_italics_RSjzp`
};
module.exports = ___CSS_LOADER_EXPORT___;
